
import { useLocation,Navigate,Outlet } from "react-router-dom";

import useAuth from "./hook/useAuth";

const RequiredAuth = ({allowedRoles}) =>{
    
    const {user} = useAuth()
    const location = useLocation()
    
    // console.log("role = " + user)
    // console.log( allowedRoles)

    return(
       //<></>
        (user === allowedRoles && user !== (null || '')) ? <Outlet/> : <Navigate to={"/login"} state={{from: location}} replace />
        // auth.role === allowedRoles ? <Outlet/> :  <Navigate to={"/login"} state={{from: location}} replace />
        //(roles=> allowedRoles?.includes(roles) ) 
        //auth?.roles?.find(role => allowedRoles?.includes(role)) ? <Outlet /> : <Navigate to={"/login"} state={{from: location}} replace />
        // auth.role === allowedRoles ? <Outlet /> : <Navigate to={"/login"} state={{from: location}} replace />
        //
        //auth.roles.find(role => allowedRoles.includes(role) ) ? <Outlet /> : <Navigate to={"/login"} state={{from: location}} replace />

        // auth?.roles?.find(role => allowedRoles?.includes(role) )
           // // ? <Outlet /> 
        //     :
        //     //  auth?.user ? <Navigate to={"/login"} state={{from: location}} replace /> :                   
        //     <Navigate to={"/login"} state={{from: location}} replace />
        
    )
}

export default RequiredAuth;